// extracted by mini-css-extract-plugin
export default {"title":"style_title__J7Cv3","list":"style_list__Yww6s","tv_show_item":"style_tv_show_item__VFh+C"};